import UserAvatar from '@/js/shared/components/ui/UserAvatar';
import { AuthContext } from '@/js/shared/context/AuthContext';
import { ConferenceContext } from '@/js/shared/context/ConferenceContext';
import { infoList } from '@/js/shared/utils/DataFormat';
import { IUser } from '@/types/user';
import { Button, ButtonBase, Grid, Icon, IconButton } from '@material-ui/core';

import { makeStyles, Theme } from '@material-ui/core/styles';
import axios from 'axios';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  user: {
    paddingLeft: theme.spacing(1),
    textAlign: 'left',
    flexGrow: 1,
    wordBreak: 'break-word',
  },
}));

export const EntityBookingVisitor = ({
  visitor,
  hasAdminAccess,
}: {
  visitor: IUser;
  hasAdminAccess: boolean;
}) => {
  const { openUserPopup } = useContext(ConferenceContext);
  const classes = useStyles();

  return (
    <ButtonBase onClick={() => openUserPopup(visitor)}>
      <UserAvatar user={visitor} size="small" />
      <div className={classes.user}>
        <strong>{visitor.full_name}</strong>
        <br />
        {infoList([visitor.title, visitor.company, visitor.location_city])}
      </div>
    </ButtonBase>
  );
};
EntityBookingVisitor.displayName = 'EntityBookingVisitor';
